import React, { useEffect } from 'react';

interface IndexPageProps {
  location: Location;
}
const IndexPage: React.FC<IndexPageProps> = () => {
  useEffect(() => {
    location.href = 'https://game.devsisters.com/';
  }, []);
  return null;
};
export default IndexPage;
